module.exports = __webpack_public_path__ + "img/22.fd43203e.jpg";